//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------

import Loading from 'components/Loading';
import { get, cloneDeep } from "lodash";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
//  -- Constants ----------------------
import { Col, Row } from 'antd';

import { Button, FormLabel } from '@mui/material';
import PageImagePicker from "components/AdminBooks/PageImagePicker";
import VideoPicker from "components/AdminBooks/VideoPicker";
import { handleUpdateWelcomeVideos } from "store/welcomeVideo/thunks"
import styled from 'styled-components';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';

const ImageContainer = styled.div`
    img{
        max-height:180px;
    }
`;

export const WelcomeVideoNew = ({ videoDrawer, setVideoDrawer, welcomeVideo }) => {
    const [videoObj, setVideoObj] = useState({})
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const showAlert = useAlert()
    useEffect(() => {
        if (welcomeVideo) {
            const metadata = welcomeVideo.metadata || {};
            
            setVideoObj({
                ...welcomeVideo,
                metadata: {
                    ...metadata,
                    isActive: metadata.isActive !== undefined ? metadata.isActive : false,
                    roleFilters: metadata.roleFilters || { teacher: true, student: false }
                }
            });
        }
    }, [welcomeVideo])

    const updateVideos = async (data) => {
        const dataToUpdate = data ? data : videoObj;

        const roleFilters = get(dataToUpdate, "metadata.roleFilters", { teacher: true, student: false });
        if (!roleFilters.teacher && !roleFilters.student) {
          showAlert('Select at least one role to display this video', 'error');
          return;
        }  
        setLoading(true);
        if (dataToUpdate.metadata && 
            Object.keys(dataToUpdate.metadata).length > 0 && 
            (!dataToUpdate.metadata.startDate && 
             !dataToUpdate.metadata.endDate && 
             (!dataToUpdate.metadata.selectedDays || dataToUpdate.metadata.selectedDays.length === 0) &&
             (!dataToUpdate.metadata.roleFilters || 
              (!dataToUpdate.metadata.roleFilters.teacher && !dataToUpdate.metadata.roleFilters.student)))) {
            const isActive = dataToUpdate.metadata.isActive !== undefined ? dataToUpdate.metadata.isActive : false;
            dataToUpdate.metadata = { isActive };
        }
        
        await dispatch(handleUpdateWelcomeVideos(dataToUpdate));
        setLoading(false);
        // if(!data){
        //  setVideoDrawer(false);
        // }
       
    }
    const onCangeValue = (key, value) => {
        const re = cloneDeep(videoObj)
        re[key] = value
        setVideoObj(re);
    }
    
    const handleDateChange = (type, value) => {
        const metadata = videoObj.metadata || {};
        metadata[type === 'start' ? 'startDate' : 'endDate'] = value;
        if (!metadata.startDate && !metadata.endDate && (!metadata.selectedDays || metadata.selectedDays.length === 0) &&
            (!metadata.roleFilters || (!metadata.roleFilters.teacher && !metadata.roleFilters.student))) {
            onCangeValue('metadata', {});
        } else {
            if (!metadata.selectedDays) {
                metadata.selectedDays = [];
            }
            if (!metadata.roleFilters) {
                metadata.roleFilters = { teacher: true, student: false };
            }
            if (metadata.isActive === undefined) {
                metadata.isActive = false;
            }
            onCangeValue('metadata', metadata);
        }
    }
    
    const handleDaySelect = (selectedDays) => {
        const metadata = videoObj.metadata || {};
        metadata.selectedDays = selectedDays;
        if (!metadata.startDate && !metadata.endDate && 
            (!selectedDays || selectedDays.length === 0) &&
            (!metadata.roleFilters || (!metadata.roleFilters.teacher && !metadata.roleFilters.student))) {
            onCangeValue('metadata', {});
        } else {
            if (!metadata.roleFilters) {
                metadata.roleFilters = { teacher: true, student: false };
            }
            if (metadata.isActive === undefined) {
                metadata.isActive = false;
            }
            onCangeValue('metadata', metadata);
        }
    }
    
    const handleRoleFilterChange = (roleFilters) => {
        const metadata = videoObj.metadata || {};
        metadata.roleFilters = roleFilters;
        if (!metadata.startDate && !metadata.endDate && 
            (!metadata.selectedDays || metadata.selectedDays.length === 0) &&
            (!roleFilters.teacher && !roleFilters.student)) {
            onCangeValue('metadata', {});
        } else {
            if (!metadata.selectedDays) {
                metadata.selectedDays = [];
            }
            if (metadata.isActive === undefined) {
                metadata.isActive = false;
            }
            onCangeValue('metadata', metadata);
        }
    }
    
    const handleToggleActive = (isActive) => {
        const metadata = videoObj.metadata || {};
        metadata.isActive = isActive;
        const updatedVideoObj = { ...videoObj, metadata };
        setVideoObj(updatedVideoObj);
        updateVideos(updatedVideoObj);
    }
    
    const handleToggleInActive = (isActive) => {
        handleToggleActive(isActive);
    }
    
    return (
  <>
        <Row style={{ height: "100%", width: "100%" }}>
            <Col lg={12} xs={24} style={{ paddingRight: 16,marginBottom:30 }}>
                <VideoPicker
                    poster={get(videoObj, "poster")}
                    src={get(videoObj, "src")}
                    onChange={(item) => { 
                        onCangeValue("src", item.url)
                        updateVideos({...videoObj,src:item.url})
                     }}
                    onChangeDescription={(txt) => { onCangeValue("displayName", txt) }}
                    description={get(videoObj, "displayName")}
                    hasDescription
                    startDate={get(videoObj, "metadata.startDate")}
                    endDate={get(videoObj, "metadata.endDate")}
                    onDateChange={handleDateChange}
                    isWelcomeVideo={true}
                    initialSelectedDays={get(videoObj, "metadata.selectedDays", [])}
                    onDaySelect={handleDaySelect}
                    initialRoleFilters={get(videoObj, "metadata.roleFilters", { teacher: true, student: false })}
                    onRoleFilterChange={handleRoleFilterChange}
                    isActive={get(videoObj, "metadata.isActive", false)}
                    onToggleActive={handleToggleActive}
                    onToggleInActive={handleToggleInActive} />
            </Col>
                <Col lg={12} xs={24} style={{ paddingRight: 16, paddingLeft: 16 }}>
                    <FormLabel style={{ marginBottom: 30 }} component="legend">Cover image:</FormLabel>
                    <ImageContainer>
                <PageImagePicker
                    src={get(videoObj, "poster")}
                    path={`/resources`}
                    onChange={item => { 
                        onCangeValue("poster", item.url)
                        updateVideos({...videoObj,poster:item.url})
                     }}
                     style={{height:"max-content"}}
                    hasDescription={false}
                        />
                    </ImageContainer>
                <Button
                    disabled={!videoObj || !videoObj.id || loading }
                    style={{marginTop:30}}
                    fullWidth variant="contained" color="primary" onClick={()=>updateVideos()}
                >
                    {loading ? <Loading white size={15} /> : null}  Update
                </Button>
            </Col>
            </Row>
        </>
    )
}